import { Grid, Tooltip, useMediaQuery, useTheme } from "@material-ui/core";
import { ArrowDownward, Block, MoneyOffSharp, Save } from "@material-ui/icons";
import CloseIcon from "@material-ui/icons/Close";
import { POSITION_CONSULTANT } from "app/appConfig";
import CommonButton from "app/common/Component/Button/CommonButton";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import PopupForm from "app/common/Component/Popup/PopupForm";
import GlobitsAutocomplete from "app/common/form/GlobitsAutocomplete";
import GlobitsAutocompleteTextAndSelect from "app/common/form/GlobitsAutocompleteTextAndSelect";
import GlobitsCheckBox from "app/common/form/GlobitsCheckBox";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsNumberInput from "app/common/form/GlobitsNumberInput";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import GlobitsVNDCurrencyInput from "app/common/form/GlobitsVNDCurrencyInput";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import { STATUS_TREATMENT_LOCK, TYPE_CARD } from "app/common/LocalConst";
import { formatMoney, getPriceTypeService } from "app/common/LocalFunction";
import { pagingClientCard } from "app/services/ClientCardService";
import { pagingDepartment } from "app/services/DepartmentService";
import { pagingDrug } from "app/services/DrugService";
import { pagingHealthCareService } from "app/services/HealthCareService";
import { useStore } from "app/stores";
import { getIn, useFormikContext } from "formik";
import { observer } from "mobx-react";
import { forwardRef, memo, useEffect } from "react";
import * as Yup from "yup";
import PaymentVoucherPopup from "../../FeeTab/Popup/PaymentVoucherPopup";
import RowTotalTreatmentPlan from "../../RegisterProductTab/Component/RowTotalTreatmentPlan";
import PaServiceRegisterTable from "../Component/PaServiceRegisterTable";
import RegisterServiceStaffsRevenue from "./RegisterServiceStaffsRevenue";

const RegisterTreatmentPlanPopup = ({
  open,
  handleClose,
  onSubmit,
  initRegisterTreatmentPlan,
  listVatPercent,
  customerSourceWalkIn,
  listStk,
  listPaymentMethod,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const { handleGetListVatPercent, initialPatient } =
    useStore().patientManagementStore.patientGeneralStore;
  const department = useDefaultDepartment();
  useEffect(() => {
    handleGetListVatPercent();
  }, []);
  const validationSchema = Yup.object().shape({
    department: Yup.object().nullable().required("Chưa cơ sở!"),
    price: Yup.number()
      .min(0, "Giá phải lớn hơn 0!")
      .nullable()
      .required("Chưa nhập giá!"),
    staffRevenues: Yup.array()
      .of(
        Yup.object()
          .shape({
            position: Yup.object()
              .nullable()
              .required("Bắt buộc nhập chức danh"),
            staff: Yup.object().nullable(),
            source: Yup.object().nullable(),
          })
          .test(
            "position-and-staff-required",
            "Phải chọn cả chức danh và nhân viên!",
            function (value) {
              const { position, staff } = value || {};
              return position && staff;
            }
          )
      )

      .test(
        "at-least-one-consultant",
        "Cần phân bổ cho ít nhất 1 tư vấn viên!",
        function (staffRevenues) {
          console.log("staffRevenues", staffRevenues);
          if (!Array.isArray(staffRevenues)) return false;
          return staffRevenues.some(
            (item) =>
              item?.position?.code === POSITION_CONSULTANT ||
              item?.staff?.position?.code === POSITION_CONSULTANT
          );
        }
      )
      .nullable(),
  });

  // let initSourceRevenue = !initRegisterTreatmentPlan?.id
  //   ? [
  //       {
  //         source: initialPatient?.patientInfo?.currentPatientSource
  //           ? initialPatient?.patientInfo?.currentPatientSource
  //           : customerSourceWalkIn,
  //         percentRevenue: 100,
  //       },
  //     ]
  //   : initRegisterTreatmentPlan?.sourceRevenues;
  const source = initialPatient?.patientInfo?.currentPatientSource;

  return (
    <PopupForm
      open={open}
      size="xl"
      handleClose={handleClose}
      title={`${initRegisterTreatmentPlan?.id ? "Chỉnh sửa" : "Thêm"
        }  liệu trình ok`}
      formik={{
        initialValues: {
          ...initRegisterTreatmentPlan,
          department: initRegisterTreatmentPlan?.id
            ? initRegisterTreatmentPlan?.department
            : department,
          sourceRevenue: source,
        },
        validationSchema: validationSchema,
        onSubmit: onSubmit,
        enableReinitialize: true,
      }}
      action={({ isSubmitting, values }) => {
        return (
          <div className="flex-center gap-1">
            {initRegisterTreatmentPlan?.cardStatus ===
              STATUS_TREATMENT_LOCK && (
                <>
                  <PaymentVoucherButton
                    isMobile={isMobile}
                    patient={initialPatient?.patientInfo}
                    treatmentPlanCard={{ id: values?.id }}
                    listPaymentMethod={listPaymentMethod}
                    listStk={listStk}
                    remainingAmount={values?.remainingAmount}
                    customerSourceWalkIn={customerSourceWalkIn}
                    department={values?.department}
                  />
                </>
              )}
            {initRegisterTreatmentPlan?.cardStatus !==
              STATUS_TREATMENT_LOCK && (
                <CommonButton
                  type="submit"
                  className="btn-primary"
                  disabled={isSubmitting}
                >
                  {!isMobile && <Save className="mr-2 " />}
                  {`${initRegisterTreatmentPlan?.id ? "Chỉnh sửa" : "Thêm"
                    }  liệu trình`}
                </CommonButton>
              )}

            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <ValueForm
              listVatPercent={listVatPercent}
              patient={initialPatient?.patientInfo}
              customerSourceWalkIn={customerSourceWalkIn}
            />
          </>
        );
      }}
    </PopupForm>
  );
};

const ValueForm = observer(
  ({ listVatPercent, patient, customerSourceWalkIn }) => {
    const { setFieldValue, values } = useFormikContext();
    let currentConsultant = patient?.currentConsultant;
    let currentTelesale = patient?.currentTelesale || patient?.currentTelesale2;
    let totalAmountRevenues = 0;

    if (values?.priceWithTax) {
      totalAmountRevenues = +values?.totalAmount - (+values?.discount || 0);
    } else {
      totalAmountRevenues =
        +values?.totalAmount -
        (+values?.discount || 0) +
        (+values?.taxTotal || 0);
    }

    const handleAddProductAndService = () => {
      let feeItemSerive;
      let feeItemDrug;

      if (values?.drugPush && values?.servicePush) {
        feeItemDrug =
          values?.drugPush?.drugUnitPrices?.length > 0
            ? getPriceTypeService(
              getIn(values, "patientTypeService"),
              values?.drugPush?.drugUnitPrices || []
            )
            : null;
        feeItemSerive =
          values?.servicePush?.serviceFeeList?.length > 0
            ? getPriceTypeService(
              getIn(values, "patientTypeService"),
              values?.servicePush?.serviceFeeList || []
            )
            : null;
        let newDrug = {
          drug: values?.drugPush,
          soldQuantity: 1,
          currentEdit: true,
          price: feeItemDrug?.price ? +feeItemDrug?.price : 0,
          isEditable: true,
        };
        let newService = {
          service: values?.servicePush,
          name: values?.servicePush?.tradeName || values?.servicePush?.name,
          quantity: 1,
          currentEdit: true,
          price: feeItemSerive?.price ? +feeItemSerive?.price : 0,
          isEditable: true,
        };
        setFieldValue("drugs", [...(values?.drugs || []), { ...newDrug }]);
        setFieldValue("paServiceRegister", [
          ...(values?.paServiceRegister || []),
          { ...newService },
        ]);
        setFieldValue(
          "totalAmount",
          +values?.totalAmount +
          (+feeItemSerive?.price || 0) +
          (+feeItemDrug?.price || 0)
        );
      } else if (values?.drugPush) {
        // set thuoc
        feeItemDrug =
          values?.drugPush?.drugUnitPrices?.length > 0
            ? getPriceTypeService(
              getIn(values, "patientTypeService"),
              values?.drugPush?.drugUnitPrices || []
            )
            : null;
        setFieldValue(
          "totalAmount",
          +values?.totalAmount + (+feeItemDrug?.price || 0)
        );

        let newDrug = {
          drug: values?.drugPush,
          soldQuantity: 1,
          currentEdit: true,
          price: feeItemDrug?.price ? +feeItemDrug?.price : 0,
          isEditable: true,
        };

        setFieldValue("drugs", [...(values?.drugs || []), { ...newDrug }]);
      } else {
        // set dv
        feeItemSerive =
          values?.servicePush?.serviceFeeList?.length > 0
            ? getPriceTypeService(
              getIn(values, "patientTypeService"),
              values?.servicePush?.serviceFeeList || []
            )
            : null;
        setFieldValue(
          "totalAmount",
          +values?.totalAmount + (+feeItemSerive?.price || 0)
        );
        let newService = {
          service: values?.servicePush,
          name: values?.servicePush?.tradeName || values?.servicePush?.name,
          quantity: 1,
          currentEdit: true,
          price: feeItemSerive?.price ? +feeItemSerive?.price : 0,
          isEditable: true,
        };
        setFieldValue("paServiceRegister", [
          ...(values?.paServiceRegister || []),
          { ...newService },
        ]);
      }

      setFieldValue("servicePush", null);
      setFieldValue("drugPush", null);
    };

    const handleOnChangeTreatment = (value) => {
      setFieldValue("clientCard", value);
      setFieldValue("isTotalPriceUsed", value?.isTotalPriceUsed);

      let feeItem;
      let price;
      let totalAmount;
      if (value?.isTotalPriceUsed) {
        feeItem =
          value?.clientCardFees?.length > 0
            ? getPriceTypeService(
              getIn(values, "patientTypeService"),
              value?.clientCardFees || []
            )
            : null;

        price = feeItem?.price || value?.totalNetPrice;
        totalAmount = price * values?.quantity;
      } else {
        let totalAmountServices = 0;
        let totalAmountDrugs = 0;
        if (value?.services && value?.services?.length > 0) {
          totalAmountServices = value?.services?.reduce((acc, curr) => {
            return acc + curr?.quantity * curr?.netPrice;
          }, 0);
        }
        if (value?.products && value?.products?.length > 0) {
          totalAmountDrugs = value?.products?.reduce((acc, curr) => {
            return acc + curr?.quantity * curr?.netPrice;
          }, 0);
        }
        totalAmount = price = totalAmountServices + +totalAmountDrugs;
      }

      if (
        (value?.services && value?.services?.length > 0) ||
        (value?.products && value?.products?.length > 0)
      ) {
        let formatDataService = value?.services?.map((el) => ({
          service: el?.service,
          name: el?.service?.tradeName || el?.service?.name,
          quantity: el?.quantity,
          note: "",
          unLimited: el?.unLimited,
          price: el?.netPrice,
          isEditable: el?.isEditable,
        }));

        let formatDataDrug = value?.products?.map((el) => ({
          drug: el?.drug,
          soldQuantity: el?.quantity,
          price: el?.netPrice,
          isEditable: el?.isEditable,
        }));

        let revenueAllocations = value?.revenueAllocations || [];
        if (revenueAllocations) {
          let staffRevenues = revenueAllocations?.map((el) => ({
            position: el?.position,
            percentRevenue: el?.commissionRate,
            source: patient?.currentPatientSource
              ? patient?.currentPatientSource
              : customerSourceWalkIn,
            staff:
              currentConsultant?.position?.code === el?.position?.code
                ? currentConsultant
                : currentTelesale?.position?.code === el?.position?.code
                  ? currentTelesale
                  : null,
          }));
          setFieldValue("staffRevenues", staffRevenues);
        }

        setFieldValue("paServiceRegister", formatDataService);
        setFieldValue("drugs", formatDataDrug);
      } else {
        setFieldValue("paServiceRegister", []);
        setFieldValue("drugs", []);
      }

      let taxPercent = feeItem?.serviceVAT?.vatPercent?.toString() || 0;

      setFieldValue("price", price);
      setFieldValue("totalAmount", totalAmount);
      setFieldValue("priceWithTax", feeItem?.vatIncluded);
      setFieldValue("taxPercent", taxPercent);
      setFieldValue("patientTypeService", {
        ...feeItem?.patientTypeService,
        price: feeItem?.price,
      });

      let taxTotal;
      if (feeItem?.vatIncluded) {
        taxTotal =
          ((price * values?.quantity - values?.discount) /
            (+taxPercent + 100)) *
          +taxPercent;
      } else {
        taxTotal =
          (price * values?.quantity - (values?.discount || 0)) *
          ((+taxPercent || 0) / 100);
      }
      setFieldValue("taxTotal", taxTotal);
    };

    const handleOnChangePatientTypeService = (value) => {
      setFieldValue("patientTypeService", value);
      let vatPercent = +value?.serviceVAT?.vatPercent || 0;

      setFieldValue("price", value?.price);
      setFieldValue("priceWithTax", value?.vatIncluded);
      setFieldValue("taxPercent", vatPercent?.toString());

      let taxTotal;
      if (value?.vatIncluded) {
        taxTotal =
          ((value?.price * values?.quantity - values?.discount) /
            (vatPercent + 100)) *
          vatPercent;
      } else {
        taxTotal =
          (value?.price * values?.quantity - values?.discount) *
          ((vatPercent || 0) / 100);
      }
      setFieldValue("taxTotal", taxTotal);
    };

    const handleOnChangePrice = (e) => {
      let price = +e?.target?.value;
      let totalAmount = values?.quantity * price;
      setFieldValue("price", price);
      setFieldValue("totalAmount", totalAmount);
      let discount = values?.discount;

      if (values?.percentDiscount) {
        discount = (totalAmount * values?.percentDiscount) / 100;
        setFieldValue("discount", discount);
      }

      let taxTotal;
      if (values?.priceWithTax) {
        taxTotal =
          ((totalAmount - discount) / (+values?.taxPercent + 100)) *
          +values?.taxPercent;
      } else {
        taxTotal =
          (totalAmount - discount) * ((+values?.taxPercent || 0) / 100);
      }

      setFieldValue("taxTotal", taxTotal);
    };

    const handleOnChangeTotalAmount = (e) => {
      let totalAmount = e.target.value;
      setFieldValue("totalAmount", totalAmount);
      setFieldValue("price", totalAmount / (values?.quantity || 1));
      let discount = values?.discount;
      if (values?.percentDiscount) {
        discount = (totalAmount * values?.percentDiscount) / 100;
        setFieldValue("discount", discount);
      }
      let taxTotal;
      if (values?.priceWithTax) {
        taxTotal =
          ((totalAmount - discount) / (+values?.taxPercent + 100)) *
          +values?.taxPercent;
      } else {
        taxTotal =
          (totalAmount - discount) * ((+values?.taxPercent || 0) / 100);
      }

      setFieldValue("taxTotal", taxTotal);
    };

    const handleChangeEndDate = (date) => {
      setFieldValue("endDate", date);

      values?.paServiceRegister?.forEach((item, index) => {
        if (!item?.unLimited) {
          setFieldValue(`paServiceRegister[${index}].expiryDate`, date);
        }
      });

      values?.drugs?.forEach((item, index) => {
        if (!item?.unLimited) {
          setFieldValue(`drugs[${index}].expiryDate`, date);
        }
      });
    };

    return (
      <>
        {/* <FormikFocusError /> */}
        <Grid container spacing={1}>
          <Grid item xs={12} md={9}>
            {values?.oldTreatmentPlanCard && (
              <Grid
                container
                spacing={1}
                style={{ backgroundColor: "aliceblue", marginBottom: "8px" }}
              >
                <Grid item xs={12} sm={12} md={12}>
                  <OldTreatment />
                </Grid>
              </Grid>
            )}

            <Grid container spacing={1}>
              <Grid item xs={12} sm={6} md={2}>
                <GlobitsPagingAutocomplete
                  api={pagingDepartment}
                  name={"department"}
                  label="Cơ sở"
                  required
                />
              </Grid>
              <Grid item xs={6} sm={6} md={2}>
                <GlobitsDateTimePicker
                  name={"startDate"}
                  label="Ngày đăng ký"
                  maxDateMessage="Ngày đăng ký phải trước ngày hiện tại"
                  maxDate={new Date()}
                  isDateTimePicker
                />
              </Grid>
              <Grid item xs={6} sm={6} md={2}>
                <GlobitsDateTimePicker
                  name={"endDate"}
                  label="Ngày hết hạn sử dụng"
                  isDateTimePicker
                  onChange={(date) => handleChangeEndDate(date)}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <GlobitsPagingAutocomplete
                  api={pagingClientCard}
                  name={"clientCard"}
                  label="Liệu trình"
                  searchObject={{
                    type: TYPE_CARD[1].value,
                    isUse: true,
                  }}
                  onChange={(_, value) => {
                    handleOnChangeTreatment(value);
                  }}
                  ListboxComponent={forwardRef((props, ref) => {
                    const { children, ...other } = props;
                    return (
                      <ul {...other} ref={ref}>
                        <ol>
                          <li>{children}</li>
                        </ol>
                      </ul>
                    );
                  })}
                  renderOption={(option) => renderOptionsTrement(option)}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={2}>
                <GlobitsAutocomplete
                  label={"Loại giá"}
                  options={values?.clientCard?.clientCardFees?.map((item) => ({
                    ...item?.patientTypeService,
                    price: item?.price,
                    vatIncluded: item?.vatIncluded,
                    serviceVAT: item?.serviceVAT,
                  }))}
                  onChange={(_, value) => {
                    handleOnChangePatientTypeService(value);
                  }}
                  name={"patientTypeService"}
                  getOptionLabel={(option) => {
                    return option?.name
                      ? `${option.name}${option?.price ? `: ${formatMoney(option.price)}` : ""
                      }`
                      : "";
                  }}
                />
              </Grid>

              <Grid item xs={6} sm={6} md={2}>
                <GlobitsVNDCurrencyInput
                  label={"Giá"}
                  name={"price"}
                  onChange={handleOnChangePrice}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={2}>
                <GlobitsVNDCurrencyInput
                  label={"Thành tiền"}
                  name={"totalAmount"}
                  onChange={handleOnChangeTotalAmount}
                  disabled
                />
              </Grid>
              <Grid item xs={6} sm={6} md={2}>
                <GlobitsNumberInput
                  label={"% giảm giá"}
                  name={"percentDiscount"}
                  onChange={(e) => {
                    let percentDiscount = +e?.target.value;
                    setFieldValue("percentDiscount", percentDiscount);
                    setFieldValue(
                      "discount",
                      (values?.price * values?.quantity * percentDiscount) / 100
                    );
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={2}>
                <GlobitsVNDCurrencyInput
                  label={"Số tiền giảm"}
                  name={"discount"}
                  onChange={(e) => {
                    let discount = +e?.target.value;
                    setFieldValue("discount", discount);

                    let taxTotal;
                    if (values?.priceWithTax) {
                      taxTotal =
                        ((values?.price * values?.quantity - discount) /
                          (+values?.taxPercent + 100)) *
                        +values?.taxPercent;
                    } else {
                      taxTotal =
                        (values?.price * values?.quantity - discount) *
                        ((+values?.taxPercent || 0) / 100);
                    }

                    setFieldValue("taxTotal", taxTotal);
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={2}>
                <GlobitsAutocompleteTextAndSelect
                  options={listVatPercent || []}
                  label={"% Vat"}
                  name={"taxPercent"}
                  value={values?.taxPercent}
                  disabled={values?.priceWithTax}
                  onInputChange={(newValue) => {
                    setFieldValue("taxPercent", newValue?.toString());

                    let taxTotal;
                    if (values?.priceWithTax) {
                      taxTotal =
                        ((values?.price * values?.quantity - values?.discount) /
                          (+newValue + 100)) *
                        +newValue;
                    } else {
                      taxTotal =
                        (values?.price * values?.quantity - values?.discount) *
                        (+newValue / 100);
                    }

                    setFieldValue("taxTotal", taxTotal);
                  }}
                  displayLabel={"vatPercent"}
                  onChange={(value) => {
                    setFieldValue("taxPercent", value?.vatPercent?.toString());
                    let taxTotal;

                    if (values?.priceWithTax) {
                      taxTotal =
                        ((values?.price * values?.quantity - values?.discount) /
                          (+value?.vatPercent + 100)) *
                        +value?.vatPercent;
                    } else {
                      taxTotal =
                        (values?.price * values?.quantity - values?.discount) *
                        ((+value?.vatPercent || 0) / 100);
                    }

                    setFieldValue("taxTotal", taxTotal);
                  }}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={2}>
                <GlobitsVNDCurrencyInput
                  label={"Tiền Vat"}
                  name={`taxTotal`}
                  disabled
                />
              </Grid>

              <Grid item xs={6} sm={6} md={2}>
                <GlobitsTextField
                  label={"Mã giảm giá"}
                  name={"marketingVoucherCode"}
                />
              </Grid>
              <Grid item xs={6} sm={6} md={2} container alignItems="center">
                <GlobitsCheckBox
                  label={"Giá kèm thuế"}
                  name={"priceWithTax"}
                  disabled
                />
              </Grid>
              <Grid item xs={6} sm={6} md={3} container alignItems="center">
                <GlobitsCheckBox
                  label={"Lấy theo giá tổng"}
                  name={"isTotalPriceUsed"}
                  disabled
                />
              </Grid>

              <Grid item xs={12} sm={6} md={3}>
                <GlobitsTextField label={"Ghi chú"} name={"note"} isTextArea />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} md={3}>
            <RowTotalTreatmentPlan data={values} />
          </Grid>

          <Grid item xs={12} md={12}>
            <Grid container spacing={1}>
              <RegisterServiceStaffsRevenue totalAmount={totalAmountRevenues} />
            </Grid>
          </Grid>

          {(values?.paServiceRegister || values?.clientCard?.isEditable) && (
            <Grid item xs={12} md={12}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6} md={2}>
                  <p className="table-section-title">
                    Danh sách dịch vụ/sản phẩm
                  </p>
                </Grid>
                {values?.clientCard?.isEditable && (
                  <>
                    <Grid item xs={12} sm={6} md={2}>
                      <GlobitsPagingAutocomplete
                        disableClearable
                        label={"Chọn dịch vụ"}
                        name={"servicePush"}
                        api={pagingHealthCareService}
                        searchObject={{
                          serviceGroupIds:
                            values?.clientCard?.serviceGroups?.map(
                              (item) => item?.serviceGroup?.id
                            ) || [],
                        }}
                        getOptionLabel={(option) =>
                          option?.tradeName || option?.name || ""
                        }
                        searchFields={["tradeName", "name", "code"]}
                        // getOptionDisabled={(option) => {
                        //   const selectedService = getIn(
                        //     values,
                        //     "paServiceRegister"
                        //   );
                        //   if (
                        //     selectedService?.find(
                        //       (it) => it?.service?.id === option?.id
                        //     )
                        //   ) {
                        //     return true;
                        //   }
                        //   return false;
                        // }}
                        onChange={(_, value) => {
                          setFieldValue("servicePush", value);
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2}>
                      <GlobitsPagingAutocomplete
                        disableClearable
                        label={"Sản phẩm"}
                        api={pagingDrug}
                        searchObject={{
                          abstractProductIds:
                            values?.clientCard?.abstractProducts?.map(
                              (item) => item?.abstractProduct?.id
                            ) || [],
                        }}
                        getOptionLabel={(option) =>
                          option?.tradeName || option?.name || ""
                        }
                        searchFields={["tradeName", "name", "code"]}
                        name={"drugPush"}
                        // getOptionDisabled={(option) => {
                        //   const drugs = getIn(values, "drugs");
                        //   if (
                        //     drugs?.find((it) => it?.drug?.id === option?.id)
                        //   ) {
                        //     return true;
                        //   }
                        //   return false;
                        // }}
                        onChange={(_, value) => {
                          setFieldValue("drugPush", value);
                        }}
                      />
                    </Grid>

                    <Grid item xs={6} className="flex align-end">
                      <CommonButton onClick={handleAddProductAndService}>
                        <ArrowDownward />
                      </CommonButton>
                    </Grid>
                  </>
                )}

                <Grid item xs={12}>
                  <PaServiceRegisterTable />
                </Grid>
                <DialogErrorMessage />
              </Grid>
            </Grid>
          )}
        </Grid>
      </>
    );
  }
);

const OldTreatment = observer(() => {
  const { values } = useFormikContext();
  const serviceCount =
    Math.min(values?.oldTreatmentPlanCard?.paServiceRegister?.length, 5) || 0;
  const medicalSupplyCount =
    Math.min(
      values?.oldTreatmentPlanCard?.medicalSupplyOrders?.length,
      5 - serviceCount
    ) || 0;
  const drugCount =
    Math.min(
      values?.oldTreatmentPlanCard?.drugs?.length,
      5 - serviceCount - medicalSupplyCount
    ) || 0;

  const displayServices =
    values?.oldTreatmentPlanCard?.paServiceRegister?.slice(0, serviceCount);
  const displayMedicalSupply =
    values?.oldTreatmentPlanCard?.medicalSupplyOrders?.slice(
      0,
      medicalSupplyCount
    );
  const displayDrugs = values?.oldTreatmentPlanCard?.drugs?.slice(0, drugCount);
  return (
    <Grid container spacing={1} className="flex align-center justify-between">
      <Grid item xs={12} md={6}>
        <div className="flex mt-2" style={{ fontSize: "11px" }}>
          <div>
            Cần thu:{" "}
            <b style={{ color: "red" }}>
              {formatMoney(values?.oldTreatmentPlanCard?.amountActuallyPaid)}
            </b>
          </div>
          <span className="mx-2 text-gray-400">|</span>
          <div>
            Đã thu:{" "}
            <b style={{ color: "green" }}>
              {formatMoney(
                values?.oldTreatmentPlanCard?.totalBillPatientPaid || 0
              )}
            </b>
          </div>
          <span className="mx-2 text-gray-400">|</span>
          <div>
            {values?.oldTreatmentPlanCard?.clientCard?.code && (
              <div>
                <b style={{ color: "#007bff" }}>
                  {values?.oldTreatmentPlanCard?.clientCard?.code}{" "}
                </b>
              </div>
            )}
          </div>
          <div>
            Tiền khấu trừ lộ trình cũ:{" "}
            <b style={{ color: "red" }}>
              {formatMoney(values?.oldTreatmentPlanCard?.amountActuallyPaid)}
            </b>
          </div>
          <span className="mx-2 text-gray-400">|</span>
        </div>
        <span className="clientCard-name">
          {values?.oldTreatmentPlanCard?.clientCard?.name}
        </span>
        {(displayServices || []).map((serviceItem, serviceIndex) => (
          <div className="flex items-center mb-1" style={{ fontSize: "10px" }}>
            <div
              className="flex items-center"
              style={{ borderBottom: "1px solid gray" }}
            >
              {serviceIndex + 1}.
              <span
                style={{
                  maxWidth: "200px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  display: "inline-block",
                  verticalAlign: "middle",
                }}
                title={serviceItem?.service?.name || "Tên liệu trình"}
              >
                {serviceItem?.service?.name || "Tên liệu trình"}
              </span>
              <CloseIcon fontSize="inherit" />
              <span className="value-medical">
                {serviceItem?.quantity || 1}
              </span>
              <span className="mx-2 text-gray-400">|</span>
              <div>
                Điều trị:{" "}
                {/* <b>{serviceItem?.totalPerformedTimes || 0}</b>{" "} */}
                {!serviceItem?.unLimited && (
                  <>
                    /
                    <b style={{ color: "red" }}>
                      {serviceItem?.totalTreatmentTimes || 0}
                    </b>
                  </>
                )}
              </div>
              {serviceItem?.unLimited && (
                <Tooltip title="Không giới hạn">
                  <span className="unlimited-badge">♾️</span>
                </Tooltip>
              )}
            </div>
          </div>
        ))}

        {(displayDrugs || []).map((serviceItem, serviceIndex) => (
          <div className="flex items-center mb-1" style={{ fontSize: "10px" }}>
            <div
              className="flex items-center"
              style={{ borderBottom: "1px solid gray" }}
            >
              {serviceCount + serviceIndex + 1}.
              <span
                style={{
                  maxWidth: "200px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  display: "inline-block",
                  verticalAlign: "middle",
                }}
                title={serviceItem?.drug?.name || "Tên thuốc"}
              >
                {serviceItem?.drug?.name || "Tên thuốc"}
              </span>
              <CloseIcon fontSize="inherit" />
              <span className="value-medical">
                {serviceItem?.soldQuantity || 1}
              </span>
              {serviceItem?.unLimited && (
                <span className="unlimited-badge">♾️ Không giới hạn</span>
              )}
            </div>
          </div>
        ))}

        {(displayMedicalSupply || []).map((serviceItem, serviceIndex) => (
          <div className="flex items-center mb-1" style={{ fontSize: "10px" }}>
            <div
              className="flex items-center"
              style={{ borderBottom: "1px solid gray" }}
            >
              {serviceCount + drugCount + serviceIndex + 1}.
              <span
                style={{
                  maxWidth: "200px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  display: "inline-block",
                  verticalAlign: "middle",
                }}
                title={serviceItem?.medicalSupply?.name || "Tên vật tư"}
              >
                {serviceItem?.medicalSupply?.name || "Tên vật tư"}
              </span>
              <CloseIcon fontSize="inherit" />
              <span className="value-medical">
                {serviceItem?.soldQuantity || 1}
              </span>
              {serviceItem?.unLimited && (
                <span className="unlimited-badge">♾️ Không giới hạn</span>
              )}
            </div>
          </div>
        ))}
      </Grid>

      <Grid item xs={12} md={2} className="">
        <GlobitsVNDCurrencyInput
          name="oldTreatmentCredit"
          label="Tiền khấu trừ liệu trình cũ"
          disabled
        />
      </Grid>
    </Grid>
  );
});

const PaymentVoucherButton = observer(
  ({
    isMobile,
    patient,
    treatmentPlanCard,
    listPaymentMethod,
    listStk,
    remainingAmount,
    customerSourceWalkIn,
    department,
  }) => {
    const {
      handleOpenPaymentVoucherPopup,
      openPaymentVoucherPopup,
      initialPaymentVoucher,
      createPaymentVoucherWithListMethod,
      handleClosePaymentVoucherPopup,
    } = useStore().feeStore.serviceFeeTabStore;

    return (
      <>
        <CommonButton
          className="btn"
          onClick={() => {
            handleOpenPaymentVoucherPopup(
              patient,
              listPaymentMethod,
              customerSourceWalkIn,
              department
            );
          }}
        >
          {!isMobile && <MoneyOffSharp className="mr-2 " />} Phiếu chi
        </CommonButton>
        {openPaymentVoucherPopup && (
          <PaymentVoucherPopup
            open={openPaymentVoucherPopup}
            handleClose={handleClosePaymentVoucherPopup}
            initialPaymentVoucher={{
              ...initialPaymentVoucher,
              treatmentPlanCard,
              totalAmount: remainingAmount,
            }}
            handleSubmit={createPaymentVoucherWithListMethod}
            patient={patient}
            listPaymentMethod={listPaymentMethod}
            listStk={listStk}
          />
        )}
      </>
    );
  }
);

const DialogErrorMessage = observer(() => {
  const { openInvalidMessage, handleCloseInvalidMessage } =
    useStore().patientManagementStore.registerTreatmentPlanStore;
  return (
    <>
      {!!openInvalidMessage && (
        <ConfirmPopup
          open={!!openInvalidMessage}
          onClose={() => handleCloseInvalidMessage(null)}
          text={openInvalidMessage}
          hideConfirm
          textClose={"Quay lại"}
          title="Thao tác thất bại"
        />
      )}
    </>
  );
});

const renderOptionsTrement = (option) => {
  return (
    <div
      style={{
        gap: "16px",
        alignItems: "flex-start",
      }}
    >
      <div
        style={{
          minWidth: "100px",
          fontWeight: "bold",
          fontSize: "14px",
          color: "#000",
          wordBreak: "break-word",
        }}
      >
        {option?.name}
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          flexWrap: "wrap",
          gap: "6px",
        }}
      >
        {option?.clientCardFees?.map((el, ind) => (
          <div
            key={ind}
            style={{
              fontSize: "10px",
              borderRadius: "6px",
              whiteSpace: "nowrap",
              backgroundColor: ind % 2 === 1 ? "#f1632159" : "#a8e1a8",
              padding: "2px",
              color: "#000",
            }}
          >
            {el?.patientTypeService?.name}:{" "}
            <strong>{el?.price?.toLocaleString("vi-VN") || 0}</strong>
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(RegisterTreatmentPlanPopup);
